import React from 'react';

import { Button, H4, HStack, Text, Tooltip, VStack } from '@betterment/samba-react';

import { useAgents, useSessionState } from '../hooks/useSessionState';

export const AgentsSidebar: React.FC = () => {
  const { sessionState, setAgentConfig } = useSessionState();
  const { data: agents, isLoading } = useAgents();

  return (
    <VStack css={{ minWidth: '250px', width: '250px' }}>
      {isLoading ? (
        <Text variant="text100">Loading...</Text>
      ) : (
        <VStack css={{ gap: 'space.200' }}>
          {agents.map(agent => (
            <VStack key={agent.id} css={{ gap: 'space.100' }}>
              <HStack css={{ gap: 'space.100' }}>
                <H4 variant="title100">{agent.name}</H4>
                <Tooltip>
                  <Tooltip.Trigger asChild={true}>
                    <Tooltip.IconButton name="InfoCircle" css={{ display: 'inline-block' }} />
                  </Tooltip.Trigger>
                  <Tooltip.Content>{agent.description}</Tooltip.Content>
                </Tooltip>
              </HStack>
              <VStack css={{ gap: 'space.50' }}>
                {agent.aliases.map(alias => (
                  <Button
                    key={alias.id}
                    variant={
                      sessionState?.agentId === agent.id && sessionState.agentAliasId === alias.id
                        ? 'solidPrimary'
                        : 'ghostPrimary'
                    }
                    onClick={() => setAgentConfig({ agentId: agent.id, agentAliasId: alias.id })}
                    css={{ padding: 'space.100', justifyContent: 'flex-start' }}
                  >
                    <VStack css={{ gap: 'space.25', alignItems: 'flex-start' }}>
                      <Text>{alias.name}</Text>
                      {alias.description && (
                        <Text variant="caption" css={{ textAlign: 'left' }}>
                          {alias.description}
                        </Text>
                      )}
                    </VStack>
                  </Button>
                ))}
              </VStack>
            </VStack>
          ))}
        </VStack>
      )}
    </VStack>
  );
};
